import React from 'react'
import { IconDelete } from '../../../../components/icons/IconDelete'
import { IconArrowRight } from '../../../../components/icons/IconArrowRight'
import { IconLoader } from '../../../../components/icons/IconLoader'
import { IconMessaging } from '../../../../components/icons/IconMessaging'

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  color?: string
}

export const Spinner: React.FC<SpinnerProps> = ({ size = 'md', color = 'gray' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
  }

  return (
    <div
      className={`${sizeClasses[size]} border-2 border-${color} border-t-transparent rounded-full animate-spin`}
    ></div>
  )
}

interface ITableBtn {
  onClick?: () => void
  type: 'remove' | 'go' | 'message' | 'scratched'
  loading?: boolean
}

export const TableBtn: React.FC<ITableBtn> = ({ onClick, type, loading = false }) => {
  const renderIcon = () => {
    switch (type) {
      case 'scratched':
        return <IconLoader />
      case 'remove':
        return <IconDelete />
      case 'message':
        return <IconMessaging />
      default:
        return <IconArrowRight />
    }
  }
  return (
    <button
      onClick={onClick}
      disabled={loading}
      className={`w-[45px] min-w-[45px] h-[45px] ${type === 'scratched' && 'cursor-default'} flex items-center justify-center border-[1px] rounded-[8px] border-solid ${type === 'go' ? 'border-[#F6F7FB]' : 'border-[#D3DAEE]'} ${type === 'go' && 'bg-[#F6F7FB]'}`}
    >
      {loading ? <Spinner size="md" color="gray" /> : renderIcon()}
    </button>
  )
}
